// Map amazon-cognito-identity-js / Cognito service error names to i18n keys.
// The SDK throws Errors with `name` set to the Cognito exception class name
// (e.g. "NotAuthorizedException"). We serialise that into the Redux payload
// as `{ name, code, message }` and look up a translation here so the user
// sees their preferred language instead of the SDK's English message.

const COGNITO_ERROR_KEYS = {
  NotAuthorizedException: 'cognito-errors.invalid-credentials',
  // PreventUserExistenceErrors is enabled, so this rarely surfaces, but if
  // a server-side condition lets it through we still want a localized line.
  UserNotFoundException: 'cognito-errors.invalid-credentials',
  PasswordResetRequiredException: 'cognito-errors.password-reset-required',
  UserNotConfirmedException: 'cognito-errors.user-not-confirmed',
  LimitExceededException: 'cognito-errors.limit-exceeded',
  TooManyRequestsException: 'cognito-errors.too-many-requests',
  CodeMismatchException: 'cognito-errors.invalid-code',
  ExpiredCodeException: 'cognito-errors.expired-code',
  InvalidPasswordException: 'cognito-errors.invalid-password',
  InvalidParameterException: 'cognito-errors.invalid-parameter',
};

export default function translateCognitoError(err, t, fallbackKey = 'cognito-errors.default') {
  if (!err) return t(fallbackKey);
  const key = COGNITO_ERROR_KEYS[err.name] || COGNITO_ERROR_KEYS[err.code];
  if (key) return t(key);
  // Network failures don't have a Cognito name. The SDK relays them via
  // generic Error / TypeError instances with no .name match.
  if (err.name === 'NetworkError' || /network/i.test(err.message || '')) {
    return t('cognito-errors.network');
  }
  return t(fallbackKey);
}
